import React, { useState } from 'react';
import { Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { useSite } from '../context/SiteContext';
import { api, getCompanyId } from '../config/api';

const ContactForm: React.FC = () => {
  const { serviceGroups } = useSite();
  const [formData, setFormData] = useState({ full_name: '', email: '', phone: '', service: '', date: '', observation: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const formatDate = (d: string) => d ? d.split('-').reverse().join('/') : '';

      let observation = `Serviço: ${formData.service}`;
      if (formData.date) observation += ` | Data: ${formatDate(formData.date)}`;
      if (formData.observation) observation += ` | Obs: ${formData.observation}`;

      await api.post('/crm-lead', {
        full_name: formData.full_name,
        phone: formData.phone,
        email: formData.email,
        origin_id: '10',
        observation,
        status_id: '4',
        temperature_id: '2',
        company_id: getCompanyId(),
      });

      setSuccess(true);
      setFormData({ full_name: '', email: '', phone: '', service: '', date: '', observation: '' });
    } catch {
      setError('Erro ao enviar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {success && <Alert variant="success" className="mb-4">Mensagem enviada com sucesso! Entraremos em contato em breve.</Alert>}
      {error && <Alert variant="danger" className="mb-4">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12} className="mb-3">
            <Form.Label>Nome Completo</Form.Label>
            <Form.Control type="text" name="full_name" value={formData.full_name} onChange={handleChange} required />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} required />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label>Telefone</Form.Label>
            <Form.Control type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label>Serviço de Interesse</Form.Label>
            <Form.Select name="service" value={formData.service} onChange={handleChange} required>
              <option value="">Selecione um serviço</option>
              <option value="Consulta Inicial">Consulta Inicial</option>
              {serviceGroups.map(g => (
                <option key={g.id} value={g.description}>{g.description}</option>
              ))}
            </Form.Select>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label>Data Preferencial</Form.Label>
            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} />
          </Col>
          <Col md={12} className="mb-3">
            <Form.Label>Observação</Form.Label>
            <Form.Control as="textarea" rows={3} name="observation" value={formData.observation} onChange={handleChange} />
          </Col>
          <Col md={12}>
            <Button variant="warning" size="lg" className="w-100 text-profile-1 fw-bold" type="submit" disabled={loading}>
              {loading ? (
                <><span className="spinner-border spinner-border-sm me-2" role="status"></span>Enviando...</>
              ) : 'Solicitar Agendamento'}
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ContactForm;
